var __rspack_ns_object = JSON.parse('{"errorList":[{"parameter":"address","code":"invalidAddress","message":"The address is invalid"}]}')